document.documentElement.classList.add('js');
(() => {
  const root = document;
  const chips = [...root.querySelectorAll('.bxg-chip')];
  const bar = root.querySelector('.bxg-chips');
  const targets = chips.map(chip => root.querySelector(chip.getAttribute('href'))).filter(Boolean);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const activate = id => chips.forEach(chip => chip.setAttribute('aria-current', chip.getAttribute('href') === '#' + id ? 'true' : 'false'));
  chips.forEach(chip => chip.addEventListener('click', event => {
    const target = root.querySelector(chip.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({behavior: reduced.matches ? 'instant' : 'smooth', block: 'start'});
    history.replaceState(null, '', chip.getAttribute('href'));
    activate(target.id);
  }));
  if (bar) {
    const update = () => {
      bar.classList.toggle('stuck', bar.getBoundingClientRect().top <= 1);
      let current = targets[0];
      targets.forEach(target => { if (target.getBoundingClientRect().top <= 140) current = target; });
      if (current) activate(current.id);
    };
    addEventListener('scroll', update, {passive:true}); update();
  }
  root.querySelectorAll('.bxg-tablist').forEach(list => {
    const tabs = [...list.querySelectorAll('.bxg-tab')];
    const panels = tabs.map(tab => root.getElementById(tab.getAttribute('aria-controls')));
    const select = index => {
      tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', i === index ? 'true' : 'false'); tab.tabIndex = i === index ? 0 : -1; if (panels[i]) panels[i].hidden = i !== index; });
      tabs[index].scrollIntoView({block:'nearest',inline:'nearest',behavior:reduced.matches?'instant':'smooth'});
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault(); const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        select(next); tabs[next].focus();
      });
    });
    if (tabs.length) select(0);
  });
  root.querySelectorAll('.bxg-caution a[href^="#q-"]').forEach(link => link.addEventListener('click', event => {
    const target = root.querySelector(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault(); target.open = true;
    target.scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'start'});
    history.replaceState(null, '', link.getAttribute('href'));
  }));
  if (location.hash.startsWith('#q-')) { const target = root.querySelector(location.hash); if (target) target.open = true; }
})();
/* ---- guide v2: situation pickers + "In this section" scroll-spy ---- */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-bxg-picker]').forEach((picker, p) => {
    const row = picker.querySelector('.bxg2-pchips');
    const panels = [...picker.querySelectorAll('.bxg2-ppanel')];
    if (!row || panels.length < 2) return;
    const tabs = panels.map((panel, i) => {
      const id = `bxg2-p${p}-${i}`; panel.id = id; panel.setAttribute('role', 'tabpanel');
      const b = document.createElement('button');
      b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-controls', id);
      b.textContent = (panel.querySelector('.bxg2-ppanel-h') || {}).textContent || `Option ${i + 1}`;
      row.appendChild(b); return b;
    });
    const select = (i, scroll) => {
      tabs.forEach((t, j) => { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
      panels.forEach((x, j) => x.classList.toggle('on', j === i));
      if (scroll) tabs[i].scrollIntoView({block: 'nearest', inline: 'nearest', behavior: reduced.matches ? 'instant' : 'smooth'});
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i, true));
      t.addEventListener('keydown', e => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault(); const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; select(n, true); tabs[n].focus();
      });
    });
    picker.classList.add('ready'); select(0, false);
  });
  const tocs = [...document.querySelectorAll('.bxg2-toc')].map(t => [...t.querySelectorAll('a')].map(a => [a, document.querySelector(a.getAttribute('href'))]).filter(x => x[1]));
  const spy = () => tocs.forEach(list => {
    let cur = null; list.forEach(([a, el]) => { if (el.getBoundingClientRect().top <= 160) cur = a; });
    list.forEach(([a]) => a.classList.toggle('on', a === cur));
  });
  if (tocs.length) { addEventListener('scroll', spy, {passive: true}); spy(); }
})();
